export const stripLeadingSlash = (path: string): string =>
  path.startsWith('/') ? path.slice(1) : path;

export const ensureLeadingSlash = (path: string): string =>
  path.startsWith('/') ? path : '/' + path;
